module.exports = __webpack_public_path__ + "img/21.8db9dc4e.png";